"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _big_cat_tags_sort = require("@/api/big_cat_tags_sort");

var actions = {
  edit: function edit(_ref, catTagsIdList) {
    var commit = _ref.commit;
    // const { name, sex } = catTagsIdList
    return new Promise(function (resolve, reject) {
      (0, _big_cat_tags_sort.edit)(catTagsIdList).then(function (response) {
        var data = response.data; // commit('SET_NAME', name)

        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = {
  namespaced: true,
  // state,
  // mutations,
  actions: actions
};
exports.default = _default;